import React from "react";
import { Truncate } from "../../../../lib/Truncate";
import { Pill } from "../../../search/searchBar/Pill";
import { Languages } from "../EventsPanelParts";
import { uniqueKey } from "../../../../lib/utils";

export function EventsPill({ pills }) {
  return (
    <div>
      <Truncate show={3} more={20}>
        {pills.map(({ text, category, isShowTitle, title }, index) => (
          <Pill
            key={uniqueKey(text, index)}
            text={text}
            margin="mr-1 mb-1"
            title={isShowTitle && (title || `${category}: ${text}`)}
            className="cursor-default"
          />
        ))}
      </Truncate>
    </div>
  );
}

export function populateEventPills(props) {
  const languages = props.excludeLanguages ? [] : props.slots?.[0]?.languages || [];
  const listOfLanguages = Languages({ languages });

  const locationCategory = props.uiHashtag?.locationCategory || "";
  const hashTags = props.uiHashtag?.hashTags || [];
  const pills = [
    ...hashTags.map((text) => ({ category: "Hashtag", text })),
    ...(locationCategory ? [{ category: "locationCategory", text: locationCategory }] : []),
    ...listOfLanguages.map((text) => ({ category: "Language", text })),
  ];
  return pills;
}
